import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  class: "modal fade",
  ref: "uploadModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_3"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_4 = { class: "modal-content rounded" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header py-2 border-0 justify-content-start",
  style: {"background-color":"#3268ff"}
}, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "fw-bold fs-2",
    style: {"color":"white"}
  }, "Draft Template")
], -1)
const _hoisted_6 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-5" }
const _hoisted_7 = { class: "row g-9 mb-3 mt-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2 mt-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Pilih Aktifitas")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "row g-9 mb-3 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2 mt-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Pilih Tipe")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "d-flex flex-column mb-3 fv-row" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex align-items-center fs-6 fw-bold mb-2 mt-0"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Upload Dokumen", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "        ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "( Format dokumen .docx )", -1)
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { style: {"text-align":"end"} }
const _hoisted_24 = ["data-kt-indicator"]
const _hoisted_25 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h5", { style: {"color":"white","margin-bottom":"0px"} }, "Upload", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = ["data-kt-indicator"]
const _hoisted_33 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h5", { style: {"color":"white","margin-bottom":"0px"} }, "Download", -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form, {
              id: "kt_modal_1",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.targetData,
              ref: "formRef",
              class: "form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_el_form_item, {
                    prop: "typeAktifitas",
                    class: "mt-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.targetData.typeAktifitas,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData.typeAktifitas) = $event)),
                        placeholder: "Pilih Aktifitas",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.items.legalAktifitas,
                        searchable: true,
                        label: "name",
                        "track-by": "name",
                        "value-prop": "_id"
                      }, null, 8, ["modelValue", "options"]),
                      (_ctx.targetData.typeAktifitas == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.items.errorAktifitas), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_el_form_item, {
                    prop: "documentType",
                    class: "mt-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.targetData.documentType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.documentType) = $event)),
                        placeholder: "Pilih Tipe",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.items.legalType,
                        searchable: true
                      }, null, 8, ["modelValue", "options"]),
                      (_ctx.targetData.documentType == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.items.errorType), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.targetData.typeAktifitas === 'upload')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_16, _hoisted_20))
                    : _createCommentVNode("", true),
                  (_ctx.targetData.typeAktifitas === 'upload')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        prop: "file",
                        class: "mt-1"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("input", {
                            name: "file",
                            type: "file",
                            id: "file",
                            class: "form-control form-control-lg",
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFileUpload($event))),
                            key: _ctx.items.fileInputKey
                          }, null, 32)),
                          (_ctx.targetData.file == '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.items.errorFile), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger me-3",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.backEvent()))
                  }, " Kembali "),
                  (_ctx.targetData.typeAktifitas === 'upload')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        "data-kt-indicator": _ctx.loading ? 'on' : null,
                        class: "btn btn-lg btn-primary",
                        type: "submit"
                      }, [
                        (!_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _hoisted_27))
                          : _createCommentVNode("", true),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _hoisted_31))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_24))
                    : _createCommentVNode("", true),
                  (_ctx.targetData.typeAktifitas != 'upload')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        "data-kt-indicator": _ctx.loading ? 'on' : null,
                        class: "btn btn-lg btn-success",
                        type: "submit"
                      }, [
                        (!_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _hoisted_35))
                          : _createCommentVNode("", true),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, _hoisted_39))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_32))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}